import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=c8d8cb8a&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=c8d8cb8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d8cb8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8d8cb8a')) {
      api.createRecord('c8d8cb8a', component.options)
    } else {
      api.reload('c8d8cb8a', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=c8d8cb8a&scoped=true&", function () {
      api.rerender('c8d8cb8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2mQHwZCKPj5nm/JS/comp/GuestBox.vue"
export default component.exports